import * as Yup from 'yup';

// Validation schema for exam schedule form
export const examScheduleValidationSchema = Yup.object({
  date: Yup.date().required('Exam date is required'), // During Editing it is showing error like date should be after current date ,in case of Previous Date
  // .min(
  //   new Date(new Date().setHours(0, 0, 0, 0)),
  //   'Exam date cannot be in the past',
  // )
  startTime: Yup.string().nullable(),
  // .test('start-time-format', 'Invalid time format', function (value) {
  //   if (!value) return true; // Optional field
  //   const timeRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
  //   return timeRegex.test(value);
  // })
  endTime: Yup.string()
    .nullable()
    // .test('end-time-format', 'Invalid time format', function (value) {
    //   if (!value) return true; // Optional field
    //   const timeRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
    //   return timeRegex.test(value);
    // })
    .test(
      'end-after-start',
      'End time must be after start time',
      function (value) {
        const { startTime } = this.parent;
        if (!startTime || !value) return true;

        const startTimeDate = new Date(`2000-01-01T${startTime}`);
        const endTimeDate = new Date(`2000-01-01T${value}`);

        return endTimeDate > startTimeDate;
      },
    ),

  marks: Yup.number()
    .required('Total marks is required')
    .positive('Marks must be a positive number')
    .integer('Marks must be a whole number')
    .min(1, 'Marks must be at least 1')
    .max(1000, 'Marks cannot exceed 1000'),

  passMarks: Yup.number()
    .required('Pass marks is required')
    .positive('Pass marks must be a positive number')
    .integer('Pass marks must be a whole number')
    .min(1, 'Pass marks must be at least 1')
    .test(
      'pass-marks-validation',
      'Pass marks cannot exceed total marks',
      function (value) {
        const { marks } = this.parent;
        if (!marks || !value) return true;
        return value <= marks;
      },
    ),

  subjectName: Yup.string()
    .required('Subject is required')
    .trim()
    .min(1, 'Subject is required'),

  examType: Yup.string()
    .required('Exam type is required')
    .trim()
    .min(1, 'Exam type is required'),

  departmentName: Yup.string()
    .required('Department is required')
    .trim()
    .min(1, 'Department is required'),

  classesName: Yup.string()
    .required('Class is required')
    .trim()
    .min(1, 'Class is required'),

  sectionName: Yup.string().nullable().trim(),
});

// Initial form values
export const initialFormValues = {
  date: '',
  startTime: '',
  endTime: '',
  marks: '',
  passMarks: '',
  subjectName: '',
  examType: '',
  departmentName: '',
  classesName: '',
  sectionName: '',
};

// Helper function to convert schedule object to form values
export const scheduleToFormValues = (schedule) => {
  if (!schedule) return initialFormValues;

  return {
    date: schedule.date || '',
    startTime: schedule.startTime || '',
    endTime: schedule.endTime || '',
    marks: schedule.marks?.toString() || '',
    passMarks: schedule.passMarks?.toString() || '',
    subjectName: schedule.subjectName || '',
    examType: schedule.examType || '',
    departmentName: schedule.departmentName || '',
    classesName: schedule.classesName || '',
    sectionName: schedule.sectionName || '',
  };
};

// Helper function to convert form values to schedule object
export const formValuesToSchedule = (values, scheduleId = null) => {
  return {
    ...(scheduleId && { id: scheduleId }),
    date: values.date,
    startTime: values.startTime || null,
    endTime: values.endTime || null,
    marks: Number(values.marks),
    passMarks: Number(values.passMarks),
    subjectName: values.subjectName,
    examType: values.examType,
    departmentName: values.departmentName,
    classesName: values.classesName,
    sectionName: values.sectionName || null,
  };
};
